import { Reveal } from '../components/Reveal';
import { PhoneFrame } from '../components/PhoneFrame';

const audiences = [
  {
    label: 'FLEET MANAGERS',
    copy: 'See fleet pressure, open work, overdue items and vehicles requiring action.',
  },
  {
    label: 'ACCOUNT / SERVICE TEAMS',
    copy: 'Work from prioritised operational queues instead of fragmented calls, inboxes and notes.',
  },
  {
    label: 'OPERATIONS / MANAGEMENT',
    copy: 'Gain clearer workload, service and operational visibility across the organisation.',
  },
];

export const WhoItsFor = () => (
  <section id="who-its-for" className="scroll-mt-20 py-20 md:py-28" data-testid="who-its-for-section">
    <div className="container-relay">
      <Reveal className="max-w-2xl">
        <p className="eyebrow mb-4" data-testid="who-eyebrow">Who it&rsquo;s for</p>
        <h2 className="text-3xl font-bold tracking-tight text-[#111111] sm:text-4xl" data-testid="who-headline">
          One service layer.
          <br />
          Different views of the same operation.
        </h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-2">
        <Reveal className="md:col-span-2">
          <div
            data-testid="audience-drivers"
            className="flex h-full flex-col gap-6 overflow-hidden rounded-xl border border-[#E5E7EB] bg-white p-6 shadow-[0_4px_20px_rgba(16,24,40,0.04)] sm:p-8 md:flex-row md:items-center md:gap-12"
          >
            <div className="min-w-0 flex-1">
              <span className="font-op text-[11px] font-semibold text-[#0F5C4A]">01</span>
              <p className="font-op mt-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#111111]">Drivers</p>
              <p className="mt-3 max-w-[44ch] text-sm leading-relaxed text-[#6B7280]">
                Request help, see booking progress and know when human assistance is needed. A driver identifies
                themselves, taps what they need — MOT, service, repair or assistance — and Relay takes it from
                there. No apps to learn, no calls to make.
              </p>
              <p className="font-op mt-5 text-[10px] uppercase tracking-[0.18em] text-[#9CA3AF]">
                Pictured: the real Relay driver entry screen
              </p>
            </div>
            <div className="mx-auto w-[170px] shrink-0 md:mx-0 md:w-[190px]">
              <PhoneFrame
                src="/assets/relay-driver-entry.webp"
                alt="Relay driver entry screen offering MOT, service, repair and assistance request options"
              />
            </div>
          </div>
        </Reveal>
        {audiences.map((a, i) => (
          <Reveal key={a.label} delay={i * 0.09} className={i === 2 ? 'md:col-span-2' : ''}>
            <div
              data-testid={`audience-${a.label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
              className="flex h-full gap-5 rounded-xl border border-[#E5E7EB] bg-white p-6 shadow-[0_4px_20px_rgba(16,24,40,0.04)] sm:p-7"
            >
              <div className="min-w-0 flex-1">
                <span className="font-op text-[11px] font-semibold text-[#0F5C4A]">{String(i + 2).padStart(2, '0')}</span>
                <p className="font-op mt-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#111111]">{a.label}</p>
                <p className="mt-3 text-sm leading-relaxed text-[#6B7280]">{a.copy}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
